import { render, staticRenderFns } from "./RevokeCertificate.vue?vue&type=template&id=63bb1a0f&"
import script from "./RevokeCertificate.vue?vue&type=script&lang=ts&"
export * from "./RevokeCertificate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports